import { render, staticRenderFns } from "./VTreeAutocomplete.vue?vue&type=template&id=0658b300&"
import script from "./VTreeAutocomplete.vue?vue&type=script&lang=js&"
export * from "./VTreeAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports